<ng-container *ngIf="isDragAndDropEnabled; else normalList">
  <wlm-drag-list-custom
    *ngIf="layers?.length"
    class="drag-list nested-drag-container drag-container-single"
    [objectsToOrder]="layers"
    [settings]="settingsCustom"
    (somethingChanged)="compareSignals()"
    (droppedElement)="onDroppedElement($event)"
    [previewItemClass]="'nested-drag-container'"
  >
    <ng-template let-rowDetail let-isLastItem="isLastItem" #card>
      <div class="layer-info">
        <wlm-layer-item
          class="layer-container"
          [innerItemClass]="'layer-item-inner ' + (isLastItem ? 'layer-item-inner-last' : '')"
          [layer]="rowDetail"
          [map]="map"
          [showLayerTypeIcon]="showLayerTypeIcon"
          [isDragAndDropEnabled]="isDragAndDropEnabled"
          [isThematic]="isThematic"
          [canConfigure]="canConfigure"
          (layerItemSelected)="onSelectedLayerItem($event)"
          (layerItemDeleted)="onDeletedLayerItem($event)"
        ></wlm-layer-item>
      </div>
    </ng-template>
  </wlm-drag-list-custom>
</ng-container>
<ng-template #normalList>
  <div class="layer-list-container">
    <div class="layer-info" *ngFor="let layer of layers; let isLastItem = last">
      <wlm-layer-item
        class="layer-container"
        [innerItemClass]="'layer-item-inner ' + (isLastItem ? 'layer-item-inner-last' : '')"
        [layer]="layer"
        [map]="map"
        [showLayerTypeIcon]="showLayerTypeIcon"
        [isDragAndDropEnabled]="isDragAndDropEnabled"
        [isThematic]="isThematic"
        (layerItemSelected)="onSelectedLayerItem($event)"
        (layerItemDeleted)="onDeletedLayerItem($event)"
      ></wlm-layer-item>
    </div>
  </div>
</ng-template>
